<script setup>

import {MapboxLayer, MapboxSource} from "@studiometa/vue-mapbox-gl";
import {computed, toRef} from "vue";

const props = defineProps({
  items: Array,
  types: Object,
});

const emit = defineEmits(['selectMarker']);

const selectMarker = function(marker){
  const clickedMarkers = marker.features;
  const selectedMarker = clickedMarkers[0];

  emit('selectMarker', selectedMarker);
}

const items = toRef(props, 'items');

const features = computed(() => {
  return items.value.map(item => {
    return {
      type: "Feature",
      geometry: {
        type: "Point",
        coordinates: [item.pos.lng, item.pos.lat],
      },
      properties: {
        id: item.id,
        type: item.types[0]
      }
    }
  });
});

const iconMapping = Object.keys(props.types).flatMap(item => {
  return [
    item,
    `stadsnatuur-${item}`,
  ];
})

</script>

<template>
  <MapboxSource
    id="activiteiten"
    type="geojson"
    :options="{
      type: 'geojson',
      data: {
        id: `activiteiten`,
        type: 'FeatureCollection',
        crs: { type: 'name', properties: { name: 'urn:ogc:def:crs:OGC:1.3:CRS84' } },
        features: features
      }
    }"
    />
  <MapboxLayer
    :id="`data`"
    :options="{
          type: 'symbol',
          source: 'activiteiten',
          layout: {
							'symbol-placement': 'point',
							'symbol-z-order': 'source',
							'icon-anchor': 'bottom',
							'icon-allow-overlap': true,
              'icon-image':
              [
                'match',
                ['get', 'type'],

                ...iconMapping,
                //fallback:
                'stadsnatuur-nature',
              ]
						 },
					}"
    @mb-click="selectMarker"
  />
</template>

<style scoped>

</style>